module.exports = __webpack_public_path__ + "img/glamping_1.01883338.jpg";